import React, { useEffect } from 'react'
import Header from '../../components/Header'
import Footer from '../../components/Footer';
import StatsSection from '../../components/StatsSection';
import ProcessSection from '../../components/ProcessSection';
import Newsletter from '../../components/Newsletter';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { Helmet } from "react-helmet";

const FaqItem = ({ question, answer, defaultOpen = false }) => {
  const [open, setOpen] = React.useState(defaultOpen);
  return (
    <div className="accordion-item">
      <h2 className="accordion-header">
        <button
          className={`accordion-button ${open ? '' : 'collapsed'}`}
          type="button"
          onClick={() => setOpen(prev => !prev)}
        >
          {question}
        </button>
      </h2>
      <div className={`accordion-collapse collapse ${open ? 'show' : ''}`}> 
        <div className="accordion-body">{answer}</div>
      </div>
    </div>
  );
};

export default function BadgeDigitizing() {

    const badgeSteps = [
        { number: "01", title: "Submit Your Design", description: "Send your logo, emblem, or artwork in JPG, PNG, PDF, or AI format.", icon: "📤" },
        { number: "02", title: "Badge Digitizing", description: "We convert your design into a machine-ready embroidery file optimized for badge embroidery.", icon: "⚡" },
        { number: "03", title: "Quality Check", description: "We refine stitch density, edges, and details for professional results.", icon: "✓" },
        { number: "04", title: "File Delivery", description: "Receive your embroidery files in DST, PES, JEF, or other required formats.", icon: "🚀" }
    ];

    return (
        <>

            <Helmet>
                <title>Badge Embroidery Digitizing Services Los Angeles, CA | Grand Indigo Embroidery</title>
                <meta name="description" content="Professional badge embroidery digitizing services in Los Angeles, CA. Perfect for uniforms, corporate, and custom badges." />
                <meta name="keywords" content="badge digitizing, embroidered badge digitizing, uniform badge digitizing, Los Angeles embroidery digitizing, badge digitizing near me" />
            </Helmet>

            <Header />

            <section className="breadcrumbsection">
                <div className='container'>
                    <h1>Badge Digitizing</h1>
                    <ul className='breadcrumblinks'>
                        <li><Link to="/">Home</Link></li>
                        <li><FontAwesomeIcon icon={faChevronRight} /></li>
                        <li>Services</li>
                        <li><FontAwesomeIcon icon={faChevronRight} /></li>
                        <li>Badge Digitizing</li>
                    </ul>
                </div>
            </section>


            <section className="service-section">
                <div className="container">
                    <div className="row align-items-center mb-5">
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <div className="case-study-image">
                                <img src="/images/services/badgedigitizing1.jpg" alt="Custom Uniform Embroidery" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="case-study-content">
                                <span className="case-study-tag">Precision with Authority</span>
                                <h3 className="case-study-title">Expert Badge Digitizing Services in Los Angeles</h3>
                                <p className="case-study-description">
                                    At Grand Indigo Embroidery, we specialize in badge digitizing services in Los Angeles, California, providing precise and professional stitch files for embroidered badges. Badges require detailed digitizing to ensure clean edges, accurate stitch density, and perfect reproduction of logos, crests, or emblems.
                                </p>
                                <p className="case-study-description">
                                    Whether for schools, clubs, law enforcement, or corporate organizations, our badge embroidery digitizing services ensure your designs maintain clarity and quality when stitched. If you’re searching for reliable badge digitizing near you in Los Angeles, Grand Indigo Embroidery delivers professional, machine-ready embroidery files that meet your specifications.
                                </p>
                                <Link to="/contact" className="btn btn-primary">Get In Touch</Link>
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <StatsSection />

            <section className="service-section">
                <div className="container">
                    <div className="row align-items-center mb-5">
                        <div className="col-lg-6">
                            <div className="case-study-content">
                                <span className="case-study-tag">Structured for Clean Edges & Durability</span>
                                <h3 className="case-study-title">Custom Badge Digitizing for Logos & Emblems</h3>
                                <p className="case-study-description">
                                    Our custom badge digitizing services are tailored for organizations, teams, and businesses that require accurate, production-ready embroidery files. We optimize stitch paths, density, and design placement to ensure crisp, professional results for every badge design.
                                </p>
                                <p className="case-study-description">
                                    From simple logos to complex emblems, we provide files compatible with all major embroidery machines. Los Angeles clients trust Grand Indigo Embroidery for fast turnaround, high-quality digitizing, and consistent results. You can also order badge embroidery digitizing online for convenient service and delivery.
                                </p>
                                <Link to="/contact" className="btn btn-primary">Get In Touch</Link>
                            </div>
                        </div>
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <div className="case-study-image">
                                <img src="/images/services/badgedigitizing2.jpg" alt="Custom Uniform Embroidery" />
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <ProcessSection steps={badgeSteps} />
                                                
            <section className="faqs-section">
                <div className="container">
                    <div className="row mb-5">
                        <div className="col-12 text-center">
                            <h2 className="section-title">Frequently Asked Questions</h2>
                        </div>
                    </div>

                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="accordion" id="faqAccordion">

                                <FaqItem
                                    defaultOpen={true}
                                    question="What is badge digitizing?"
                                    answer="Badge digitizing is the process of converting logos or emblems into machine-readable embroidery files for badges."
                                />

                                <FaqItem
                                    question="Do you offer badge digitizing services in Los Angeles?"
                                    answer="Yes, Grand Indigo Embroidery provides professional badge embroidery digitizing services in Los Angeles, California."
                                />

                                <FaqItem
                                    question="Can I order badge digitizing online?"
                                    answer="Absolutely. You can order badge embroidery digitizing online and receive optimized files quickly."
                                /> 

                                <FaqItem
                                    question="What types of badges can you digitize?"
                                    answer="We digitize organizational badges, school crests, law enforcement patches, and custom designs."
                                />

                                <FaqItem
                                    question="What garments or items can use badge embroidery?"
                                    answer="Badge embroidery can be applied to uniforms, jackets, hats, bags, and promotional apparel."
                                />

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Newsletter />

            <Footer />
        </>
    )
}
